import { Map, GoogleApiWrapper } from 'google-maps-react';
import React, { useEffect, useState } from 'react';
import axios from 'axios'; 
import MarkerConfigured from './MarkerConfigured';
import {transformAddress} from '../views/Busca';


function MapContainer(props){

   const [denunciasDados, setDenunciasDados] = useState([]);

   async function getDenuncias(){
      const response = await axios.get('https://covidback19.herokuapp.com/denuncias');

      const denunciasMap = Promise.all(response.data.map(async denuncia => {

         const dado = await transformAddress(denuncia.endereco);

         return {coordenadas: dado, ...denuncia};
      }));

      return denunciasMap;
   }

   

   useEffect(() => {

      function setDenuncias(){
         getDenuncias().then(denuncias => {
            setDenunciasDados(denuncias);
         })
      }

      setDenuncias();
   }, []);

   return (
      <div className="container">

         <Map
            google={props.google}
            zoom={14}
            initialCenter={{
               lat: 40.854885,
               lng: -88.081807
            }}
            center={{
               lat: props.city.latitude,
               lng: props.city.longitude
            }}
            style={{width: '1200px', height: '500px'}}
            >
            { denunciasDados.map((denuncia, i) => {
                  return <MarkerConfigured key={i} id={i} {...props} dados={denuncia}/>
               })
            }
         </Map>
      </div>
   );
}


export default GoogleApiWrapper({
   apiKey: 'AIzaSyDpcyyTwsGXzVMphjQ3s885lors1FkG1Cw'
})(MapContainer)

/*

   static defaultProps = {
      center: {
      lat: 59.95,
      lng: 30.33
      },
      zoom: 11
   };

   render() {
      return (
      // Important! Always set the container height explicitly
      <div style={{ height: '100vh', width: '100%' }}>
         <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyDpcyyTwsGXzVMphjQ3s885lors1FkG1Cw'}}
            defaultCenter={this.props.center}
            defaultZoom={this.props.zoom}
            distanceToMouse={()=>{}}
         >
            <AnyReactComponent
               lat={59.955413}
               lng={30.337844}
               text="My Marker"
            />
         </GoogleMapReact>
      </div>
      );
   }
}

export default MapContainer;*/